module.exports = __webpack_public_path__ + "img/04.cf83cded.png";